import { HighlightedText } from '@/app/components/HighlightedText';
import { cn } from '@/utils/сn';

interface SearchItemTitleProps {
  children: string;
  truncate?: boolean;
}

export const SearchItemTitle = ({ children, truncate = false }: SearchItemTitleProps) => (
  <p className={cn('text-body-regular max-md:!text-sm max-md:!leading-[150%] text-black', truncate && 'truncate')}>
    <HighlightedText>{children}</HighlightedText>
  </p>
);
